import { message } from 'antd';

import axiosWithAuth from '@/lib/axios';
import { asyncErrorHandler } from '@/utils/asyncErrorHandler';

export const deleteTodo = async (
  todoId: string,
  closeDeleteModal: () => void
) => {
  try {
    await axiosWithAuth({
      method: 'DELETE',
      url: '/ezcon/api/todoList',
      data: { id: todoId },
    });
    message.success('刪除成功!');
  } catch (error) {
    const errObj = error.response.data;
    const errMsg = errObj.displayMessage || '刪除失敗!';
    asyncErrorHandler(errObj, errMsg, 'Error-deleteTodo:');
  } finally {
    closeDeleteModal();
  }
};
